const accepted = (rule, value, callback) => {
    if (! value) {
        callback(new Error());
    } else {
        callback();
    }
};

export default {
    fullName: [{ required: true, message: 'Your full name is required', trigger: 'blur' }],
    firstName: [{ required: true, message: 'Your first name is required', trigger: 'blur' }],
    lastName: [{ required: true, message: 'Your last name is required', trigger: 'blur' }],
    email: [
        { required: true, message: 'Your email is required', trigger: 'blur' },
        { type: 'email', message: 'This is not an valid email', trigger: 'blur' },
    ],
    email_confirmation: [{ required: true, message: 'Your email confirmation is required', trigger: 'blur' },],
    currentPassword: [{ required: true, message: 'Your password is required', trigger: 'blur' },],
    password: [{ required: true, message: 'Your password is required', trigger: 'blur' }],
    password_confirmation: [{ required: true, message: 'Your password confirmation is required', trigger: 'blur' }],
    mobile: [{ required: true, message: 'Your mobile is required', trigger: 'blur' }],
    contactNumber: [{ required: true, message: 'Your contact number is required', trigger: 'blur' }],
    message: [{ required: true, message: 'This field is required', trigger: 'blur' }],
    professionId: [{ required: true, message: 'Please select your profession', trigger: 'change' }],
    preferredLearningFormat: [{ required: true, message: 'Please select your preferred learning format', trigger: 'change' }],
    employmentStatus: [{ required: true, message: 'Please select your employment status', trigger: 'blur' }],
    membershipId: [{ required: true, type: 'string', message: 'Please select your payment frequency', trigger: 'change' }],
    agreedTnC: [{ validator: accepted, type: 'boolean', message: 'Terms and Conditions must be accepted', trigger: 'change' }],
    subscriptionPlan: [{required: true, message: 'Please select one subscription plan', trigger: 'change'}],
    recaptcha: [{ required: true, message: 'Whoops! Are you robot?', trigger: 'blur' }],
    cardName: [{ required: true, message: 'This field is required', trigger: 'blur' }],
    event: [
        { required: true, message: 'Please select your Masterclass', trigger: 'change'}
    ],
    membershipType: [{ required: true, type: 'string', message: 'Please select your membership type', trigger: 'change' }],
    accept: [{ validator: accepted, type: 'boolean', message: 'Please tick the checkbox to accept', trigger: 'change' }],
    acceptMailingList: [{ validator: accepted, type: 'boolean', message: 'Please tick the checkbox to accept', trigger: 'change' }],
    checkedDeclare: [{ validator: accepted, type: 'boolean', message: 'Please check the checkbox to declare that you have attended/watched this event.', trigger: 'change' }],
    session:  [{ required: true, message: 'Please select your session', trigger: 'change'}],
    attendanceConfirm: [{ validator: accepted, type: 'boolean', message: 'Please check the checkbox to declare that you have attended/watched this session.', trigger: 'change' }]
}
